import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("同步数据")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("保存修改")

import { ref, unref, onMounted, nextTick } from 'vue';
import { ElMessage } from 'element-plus';
import { useRoute } from 'vue-router'

/* Plugins */
import Writer from './Writer.vue'
import AsyncDialog from './ErpAsyncDialog.vue'

/* Api */
import { CpEditorApi } from '@/apis/counterpart/counterpart.api'

/* Types */
import { CounterparDetail } from '@/apis/counterpart/counterpart.type';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { query } = useRoute()

const writerRef = ref<ComponentRef<typeof Writer>>()
const dialogRef = ref<ComponentRef<typeof AsyncDialog>>()

/* 内部事件 */
const events = {

    asyncDataFromErp: () => {

        const writer = unref(writerRef)
        const dialog = unref(dialogRef)

        if (!(writer || dialog)) return

        const data = writer?.methods.getFormData()

        dialog?.funcs.showDialog()

        nextTick(() => {

            dialog?.funcs.setData(data);

        })

    }
}

/* 同步返回数据 */
const onAsyncFinish = (data: any) => {

    unref(writerRef)?.methods.setAsyncData(data)

}

/* 保存数据 */
const onSaveButtonClick = () => {
    const writer = unref(writerRef);

    writer?.elFormRef?.validate(valid => {
        if (!valid) { return }

        const editorData = writer.methods.getFormData() as CounterparDetail

        writer.methods.setLogin(true)

        CpEditorApi(editorData).then((res) => {

            if (res.succeeded) {

                ElMessage({ type: 'success', showClose: true, message: '相对方资料修改成功。', })

            }
            else {

                ElMessage({ type: 'error', showClose: true, message: `相对方资料修改失败，原因可能是：${res.errors}`, })

            }

        }).finally(() => {

            setTimeout(() => {

                writer.methods.setLogin(false)

            }, 500);

        })
    });
};

onMounted(() => {

    const dataRowId: string = query.rowId as string

    const writer = unref(writerRef)

    if (writer) {

        writer?.methods.setData(dataRowId)

    }

})


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Writer, {
      ref_key: "writerRef",
      ref: writerRef,
      titles: `相对方资料编辑`,
      isEditor: true
    }, {
      Options: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "warning",
          onClick: events.asyncDataFromErp
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: onSaveButtonClick
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512),
    _createVNode(AsyncDialog, {
      ref_key: "dialogRef",
      ref: dialogRef,
      onFinished: onAsyncFinish
    }, null, 512)
  ], 64))
}
}

})